import React from 'react'
import InstagramFeed  from 'react-ig-feed'
import 'react-ig-feed/dist/index.css'

const InstaHome = () => {
  return <InstagramFeed token="IGQVJXVHVhZAWEwZA25iTEtoUmFOV0w4WE5GT0RpQkNXbEI1NThEOWhrWVBQUVNHR3BibTF1ZAlo0bEhWNlVmUU1ic1lCMnM2eVdqc09SeVRwdS15TXVxMTE5aGtRTy1NaTFVUmg4LWZAmQnhrUGhFWmFSQQZDZD"  counter="24"/>  
}

export default InstaHome